const initialState = {};

function reducer(state = initialState, action) {
    switch (action.type) {
        case "merchant":
            return Object.assign({}, state, action.data);

        default:
            return state;
    }
}

const data = {
    name: "merchant",
    reducer: reducer,
};

export default data;